"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _interfaces = require("@fhx/interfaces");

var _attackSpeedToString = _interopRequireDefault(require("../../../../../../../helpers/attackSpeedToString"));

var _AttributeTableModule = _interopRequireDefault(require("./AttributeTable.module.scss"));

var _AttributeTable = _interopRequireDefault(require("./AttributeTable.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var AttributeTable = function AttributeTable(_ref) {
  var item = _ref.item,
      viewingCharacter = _ref.viewingCharacter,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage;

  function renderEntry(name, value) {
    var _classNames;

    var isImproved = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isInadequate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var isWarning = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    return /*#__PURE__*/_react.default.createElement("tr", {
      className: (0, _classnames.default)(_AttributeTableModule.default.entry, (_classNames = {}, _defineProperty(_classNames, _AttributeTableModule.default.inadequate, isInadequate), _defineProperty(_classNames, _AttributeTableModule.default.warning, isWarning && !isInadequate), _defineProperty(_classNames, _AttributeTableModule.default.improved, isImproved && !isWarning && !isInadequate), _classNames))
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: _AttributeTableModule.default.name
    }, name), /*#__PURE__*/_react.default.createElement("td", {
      className: _AttributeTableModule.default.value
    }, value));
  } // eslint-disable-next-line react/sort-comp


  function renderRequiredRaces() {
    if (!item.model || !item.model.usableByCharacterRaces) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.requiredRaces);
    var tags = [];
    item.model.usableByCharacterRaces.forEach(function (requRace) {
      return tags.push(requRace.i18nTag.en);
    }); // TODO: i18n

    var value = tags.join(" ");
    var isInadequate = viewingCharacter && !item.model.usableByCharacterRaces.map(function (race) {
      return race.id;
    }).includes(viewingCharacter.characterRace.id);
    return item.model.usableByCharacterRaces && renderEntry(name, value, false, isInadequate || false);
  } // eslint-disable-next-line complexity


  function renderRequiredGender() {
    if (!item.model || !item.model.requiredGender) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.requiredGender);
    var value = formatMessage(_AttributeTable.default.requiredGenderAny);
    if (item.model.requiredGender && item.model.requiredGender === _interfaces.ERequiredGenderToUseItem.MALE) value = formatMessage(_AttributeTable.default.requiredGenderMale);
    if (item.model.requiredGender && item.model.requiredGender === _interfaces.ERequiredGenderToUseItem.FEMALE) value = formatMessage(_AttributeTable.default.requiredGenderFemale);
    var isInadequate = viewingCharacter && item.model.requiredGender !== _interfaces.ERequiredGenderToUseItem.ANY && !(viewingCharacter.gender.toString() === item.model.requiredGender.toString());
    return item.model.requiredGender && renderEntry(name, value, false, isInadequate || false);
  }

  function renderRequiredClasses() {
    if (!item.model || !item.model.usableByCharacterClasses) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.requiredClasses);
    var tags = [];
    item.model.usableByCharacterClasses.forEach(function (requClass) {
      return tags.push(requClass.i18nTag.en);
    }); // TODO: i18n

    var value = tags.join(" ");
    var isInadequate = viewingCharacter && !item.model.usableByCharacterClasses.map(function (characterClass) {
      return characterClass.id;
    }).includes(viewingCharacter.characterClass.id);
    return item.model.usableByCharacterClasses && renderEntry(name, value, false, isInadequate || false);
  }

  function renderRequiredLevel() {
    if (!item.requiredLevel) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.requiredLevel); // TODO: Level needed to use sheet

    var value = item.requiredLevel; // TODO: limit level reduced

    var isInadequate = viewingCharacter && viewingCharacter.level < item.requiredLevel;
    return item.requiredLevel > 0 && renderEntry(name, value.toString(), false, isInadequate || false);
  }

  function renderRequiredMats() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    /*
        TODO
        const name = formatMessage(i18n.requiredMats);
        const value = item.requiredMatsForCrafting;
        return (
            item.requiredMatsForCrafting &&
            item.requiredMatsForCrafting.length > 0 &&
            renderEntry(name, value, false, true)
        );
        */
  }

  function renderRequiredSkills() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    /*
        TODO
        const name = formatMessage(i18n.requiredSkills);
        const value = item.requiredSkillsForCrafting;
        return (
            item.requiredSkillsForCrafting &&
            item.requiredSkillsForCrafting.length > 0 &&
            renderEntry(name, value, false, true)
        );
        */
  }

  function renderRequiredStrength() {
    if (!item.requiredStrength) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.requiredStrength);
    var value = item.requiredStrength;
    var isInadequate = viewingCharacter && viewingCharacter.mainAttributes.strength < item.requiredStrength;
    return item.requiredStrength > 0 && renderEntry(name, value.toString(), false, isInadequate || false);
  }

  function renderRequiredIntelligence() {
    if (!item.requiredIntelligence) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.requiredIntelligence);
    var value = item.requiredIntelligence;
    var isInadequate = viewingCharacter && viewingCharacter.mainAttributes.intelligence < item.requiredIntelligence;
    return item.requiredIntelligence > 0 && renderEntry(name, value.toString(), false, isInadequate || false);
  }

  function renderRequiredDexterity() {
    if (!item.requiredDexterity) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.requiredDexterity);
    var value = item.requiredDexterity;
    var isInadequate = viewingCharacter && viewingCharacter.mainAttributes.dexterity < item.requiredDexterity;
    return item.requiredDexterity > 0 && renderEntry(name, value.toString(), false, isInadequate || false);
  }

  function renderDurability() {
    if (!item.durability || !item.durabilityMax) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.durability);
    var value = "".concat(item.durability, " / ").concat(item.durabilityMax);
    var INADEQUATE_THRESHOLD = 0.2;
    var WARNING_THRESHOLD = 0.5;
    return item.durability > 0 && item.durabilityMax > 0 && renderEntry(name, value, false, item.durability / item.durabilityMax < INADEQUATE_THRESHOLD, item.durability / item.durabilityMax < WARNING_THRESHOLD);
  }

  function renderPhyAttack() {
    if (!item.phyAttkMin || !item.phyAttkMax) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.phyAttack);
    var value = "".concat(item.phyAttkMin, " - ").concat(item.phyAttkMax);
    return (item.phyAttkMin > 0 || item.phyAttkMax > 0) && renderEntry(name, value, true); // TODO
  }

  function renderMagAttack() {
    if (!item.magAttkMin || !item.magAttkMax) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.magAttack);
    var value = "".concat(item.magAttkMin, " - ").concat(item.magAttkMax);
    return (item.magAttkMin > 0 || item.magAttkMax > 0) && renderEntry(name, value, true); // TODO
  }

  function renderPhyDefense() {
    if (!item.phyDef) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.phyDefense);
    var value = item.phyDef;
    return item.phyDef > 0 && renderEntry(name, value.toString(), true); // TODO
  }

  function renderMagDefense() {
    if (!item.magDef) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.magDefense);
    var value = item.magDef;
    return value > 0 && renderEntry(name, value.toString(), true); // TODO
  }

  function renderManaBonus() {
    if (!item.manaBonus) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.manaBonus);
    var value = item.manaBonus;
    return item.manaBonus > 0 && renderEntry(name, value.toString());
  }

  function renderCastingTimeDecrement() {
    if (!item.castingTimeDecrement) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.castingTimeDecrement);
    var value = item.castingTimeDecrement;
    return item.castingTimeDecrement > 0 && renderEntry(name, value.toString(9));
  }

  function rederAvoidanceTimeDecrement() {
    if (!item.avoidanceTimeDecrement) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.avoidanceTimeDecrement);
    var value = item.avoidanceTimeDecrement;
    return item.avoidanceTimeDecrement > 0 && renderEntry(name, value.toString());
  }

  function renderAttackSpeed() {
    if (!item.attackSpeed) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
    }

    var name = formatMessage(_AttributeTable.default.attackSpeed);
    var value = (0, _attackSpeedToString.default)(item.attackSpeed);
    return item.attackSpeed > 0 && renderEntry(name, value);
  }

  return /*#__PURE__*/_react.default.createElement("table", {
    className: (0, _classnames.default)(_AttributeTableModule.default.table, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("tbody", null, renderRequiredRaces(), renderRequiredGender(), renderRequiredClasses(), renderRequiredLevel(), renderRequiredMats(), renderRequiredSkills(), renderRequiredStrength(), renderRequiredIntelligence(), renderRequiredDexterity(), renderDurability(), renderPhyAttack(), renderMagAttack(), renderPhyDefense(), renderMagDefense(), renderManaBonus(), renderCastingTimeDecrement(), rederAvoidanceTimeDecrement(), renderAttackSpeed()));
};

var _default = AttributeTable;
exports.default = _default;